import { useAppSelector } from "../../../../../../stores/hooks/hooks.ts";
import { useEffect, useMemo, useState } from "react";
import { RevButton, RevCard } from "@revmatics/catalyst";
import { CreatorCard } from "../../../../../../components/layout/components/globalSlideouts/components/creator/components/creatorCard/CreatorCard.tsx";

export const TopCreators = () => {
  const START_COUNT = 6;
  const STEP_COUNT = 10;
  const communityAggregate = useAppSelector(
    (state) => state.discoverCommunities.communityAggregate,
  );
  const [visibleCount, setVisibleCount] = useState(START_COUNT);

  const topCreators = useMemo(
    () => communityAggregate?.top_creators ?? [],
    [communityAggregate?.top_creators],
  );
  const listLength = topCreators.length;

  useEffect(() => {
    if (listLength === 0) {
      setVisibleCount(START_COUNT);
      return;
    }
    setVisibleCount((prev) => {
      const minAllowed = Math.min(START_COUNT, listLength);
      return Math.min(Math.max(prev, minAllowed), listLength);
    });
  }, [listLength]);

  const displayedCreators = useMemo(
    () => topCreators.slice(0, visibleCount),
    [topCreators, visibleCount],
  );

  if (listLength === 0) return null;

  const remaining = Math.max(0, listLength - visibleCount);
  const isShowingAll = visibleCount >= listLength;

  const getButtonText = () => {
    if (isShowingAll) return "Show less";
    if (remaining > 0 && remaining < STEP_COUNT)
      return `Last ${remaining} items`;
    return `Load ${STEP_COUNT} more`;
  };

  const handleLoadMore = () => {
    if (isShowingAll) {
      setVisibleCount(START_COUNT);
      return;
    }
    if (remaining > 0 && remaining <= STEP_COUNT) {
      setVisibleCount(listLength);
      return;
    }
    setVisibleCount((prev) => Math.min(prev + STEP_COUNT, listLength));
  };

  if (displayedCreators) {
    return (
      <RevCard>
        <h6>Top creators</h6>
        <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-4 mt-4">
          {displayedCreators.map((creator) => (
            <CreatorCard
              data={creator}
              key={`discover-communities-creator-${creator.id}`}
            />
          ))}
        </div>
        {listLength && listLength > START_COUNT && (
          <div className="flex justify-center w-full mt-4">
            <RevButton
              variant="secondary"
              text={getButtonText()}
              handleClick={handleLoadMore}
            />
          </div>
        )}
      </RevCard>
    );
  }
  return null;
};
